// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import FalklandIsland from '../_raw/flag/icon_flag_falkland_island.png';

export default () => <img src={FalklandIsland} alt="FalklandIsland" />;
